/**
 * VoiceToText – speech-to-text popup (webkitSpeechRecognition).
 * Migrated from admin4.0; used by ToolsField mic flow.
 */
import React, { useEffect, useState, useRef } from "react";
import { IconButton, Modal, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ImagePaths } from "../../Utility/ImagePaths";
import "./VoiceToText.css";

function getImgSrc(path) {
  return path?.default ?? path;
}

export default function VoiceToText(props) {
  const [transcript, setTranscript] = useState("");
  const [listenMic, setListenMic] = useState(false);
  const [textStorage, setTextStorage] = useState("");
  const recognitionRef = useRef(null);

  useEffect(() => {
    if (!window.webkitSpeechRecognition) return;

    if (listenMic) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.lang = "en-US";
      recognition.continuous = true;
      recognition.interimResults = true;
      recognition.onstart = () => setListenMic(true);
      recognition.onend = () => {};
      recognition.onresult = (event) => {
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            const chunk = event.results[i][0].transcript + " ";
            setTranscript((prev) => prev + chunk);
            setTextStorage((prev) => prev + chunk);
          }
        }
      };
      recognitionRef.current = recognition;
      recognition.start();
    } else {
      if (recognitionRef.current) {
        recognitionRef.current.stop();
        recognitionRef.current = null;
      }
    }

    return () => {
      if (recognitionRef.current) {
        try {
          recognitionRef.current.stop();
        } catch (e) {}
        recognitionRef.current = null;
      }
    };
  }, [listenMic]);

  const reset = () => {
    setTranscript("");
    setTextStorage("");
  };

  const handleMicToggle = () => {
    setListenMic((prev) => !prev);
    if (listenMic) {
      setTranscript(textStorage);
      setTextStorage(transcript);
    }
  };

  const ticker = () => {
    const textToSend = (textStorage || "").trim();
    setTranscript("");
    setTextStorage("");
    if (textToSend) props.voiceTextConverter(textToSend);
    props.listenPopUp();
  };

  const handleClose = () => {
    setTranscript("");
    setTextStorage("");
    props.listenPopUp();
  };

  return (
    <Modal open>
      <Box sx={{ position: "relative", width: "100%", height: "100%", minHeight: "100vh" }}>
        <Paper elevation={3} id="emedhub_popup_mainBox">
          <div style={{ width: "40vw", height: "60vh" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <IconButton color="primary" onClick={handleClose} size="small" sx={{ padding: "4px" }}>
                <img className="eMed_DeletePopup_CrossIcon" src={getImgSrc(ImagePaths.Close)} alt="close" />
              </IconButton>
            </Box>
            {listenMic ? (
              transcript === "" ? (
                <Typography
                  sx={{
                    width: "100%",
                    height: "46vh",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "space-around",
                    fontSize: "1dvw",
                    overflowY: "scroll",
                  }}
                >
                  Listening Now...
                </Typography>
              ) : (
                <Typography
                  sx={{
                    width: "100%",
                    height: "46vh",
                    fontSize: "0.8dvw",
                    padding: "10px",
                    overflow: "scroll",
                  }}
                >
                  {transcript}
                </Typography>
              )
            ) : transcript === "" ? (
              <Typography
                sx={{
                  width: "100%",
                  height: "40vh",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "space-around",
                  fontSize: "1dvw",
                }}
              >
                Tap Mic to Speak
              </Typography>
            ) : (
              <TextField
                variant="standard"
                sx={{ width: "100%", height: "46vh", fontSize: "2dvw", overflowY: "scroll", padding: "10px" }}
                className="textarea"
                multiline
                type="text"
                value={textStorage}
                disabled={props.micTextEditDisabled}
                onChange={(e) => setTextStorage(e.target.value)}
                InputProps={{ disableUnderline: true }}
              />
            )}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              {listenMic ? (
                " "
              ) : (
                <IconButton color="primary" curser="pointer">
                  <img
                    style={{ width: "4vw", height: "4vh" }}
                    onClick={reset}
                    src={getImgSrc(ImagePaths.reply)}
                    alt="reset"
                  />
                </IconButton>
              )}
              {listenMic ? (
                <IconButton className="eMed_voice_to_Text" color="primary" cursor="pointer">
                  <Box>
                    <img
                      style={{
                        width: "7vw",
                        height: "7vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "0vh",
                      }}
                      onClick={handleMicToggle}
                      src={getImgSrc(ImagePaths.Mic)}
                      alt="mic"
                    />
                  </Box>
                </IconButton>
              ) : (
                <IconButton color="primary" cursor="pointer">
                  <img
                    style={{ width: "6vw", height: "6vh" }}
                    onClick={handleMicToggle}
                    src={getImgSrc(ImagePaths.Mic)}
                    alt="mic"
                  />
                </IconButton>
              )}
              {listenMic ? (
                ""
              ) : (
                <IconButton curser="pointer" color="primary">
                  <img
                    style={{ width: "3vw", height: "3vh" }}
                    onClick={ticker}
                    src={getImgSrc(ImagePaths.Check)}
                    alt="tick"
                  />
                </IconButton>
              )}
            </div>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
}
